import { useIntl } from "react-intl"

import { StaffBodyTextXS } from "@doktor-se/bones-ui"

import { useAppSelector } from "lib/hooks"
import { selectContactMyClinicQueue } from "reducers/queue/queue.reducer"

const ContactMyClinicCounter = () => {
  const intl = useIntl()
  const conversations = useAppSelector(selectContactMyClinicQueue)
  const conversationsAmount = conversations?.length || 0

  return (
    <div>
      <StaffBodyTextXS as="p">
        {intl.formatMessage({ id: "conversations.queue.before_eod" }, { count: conversationsAmount })}
      </StaffBodyTextXS>
    </div>
  )
}

export default ContactMyClinicCounter
